const REASONS = [
  {
    iconName: 'Verified',
    heading: 'Flexible Bookings',
    subtext:
      'Plans change. That’s why we offer free cancellation on most hotels & rental cars.'
  },
  {
    iconName: 'Discount',
    heading: 'Incredible Deals',
    subtext:
      'Check out with confidence. Priceline members always get our best price.',
    href: '/static-pages/best-price-guarantee.html'
  },
  {
    iconName: 'Cars',
    heading: 'No Flight? No Problem',
    subtext:
      'Bundle hotel & rental car deals to build your perfect getaway. No airtime required.'
  },
  {
    iconName: 'Help',
    heading: 'Help 24/7',
    subtext:
      'We’re always here for you – reach us 24 hours a day, 7 days a week.',
    href: '/coronavirus'
  }
]

export default REASONS
